var map = {
	"./archive.json": [
		827,
		1473
	],
	"./news.json": [
		823,
		2
	],
	"./projects.json": [
		828,
		1472
	],
	"./storer-creek.json": [
		824,
		1
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 231;


//////////////////
// WEBPACK FOOTER
// ./app/.generated/collections lazy ^\.\/.*\.json$
// module id = 231
// module chunks = 1474